import { useEffect, useRef, useState } from 'react'
import { usePrefersReducedMotion } from '../../../hooks/usePrefersReducedMotion'
import styles from './Reveal.module.css'

const Reveal = ({ children, delay = 0, as: Component = 'div', className = '', ...props }) => {
  const ref = useRef(null)
  const prefersReducedMotion = usePrefersReducedMotion()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (prefersReducedMotion) {
      setIsVisible(true)
      return undefined
    }

    const element = ref.current
    if (!element) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        setIsVisible(true)
        observer.disconnect()
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
    )

    observer.observe(element)
    return () => observer.disconnect()
  }, [prefersReducedMotion])

  const classes = [styles.reveal, isVisible && styles.visible, className]
    .filter(Boolean)
    .join(' ')

  return (
    <Component
      ref={ref}
      className={classes}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...props}
    >
      {children}
    </Component>
  )
}

export default Reveal
